import CampoHash from "../components/CampoHash/CampoHash";

/**
 * Utilitários para as telas de listagem
 */

// Breakpoints padrão para responsividade das tabelas
export const BREAKPOINTS_PADRAO = {
  pequeno: 576,  // Telas muito pequenas (celulares)
  medio: 768,    // Telas médias (tablets)
  grande: 992    // Telas maiores
};

// Opções para o dropdown de situação cadastro
export const OPCOES_SITUACAO = [
  { value: "ATIVO", label: "Ativo" },
  { value: "INATIVO", label: "Inativo" }
];

// Função para renderizar o status com a classe adequada
export const renderizarStatus = (item, getStatus = null) => {
  let status;

  if (getStatus) status = getStatus(item)?.toLowerCase() || 'inativo';
  else status = typeof item.situacaoCadastro === 'string' ? item.situacaoCadastro.toLowerCase() : 'inativo';

  const statusCapitalizado = status.charAt(0).toUpperCase() + status.slice(1);
  return (
    <span className={`status-${status}`}>
      {statusCapitalizado}
    </span>
  );
};

export const COLUNA_SITUACAO = (getStatus = null) => ({
  titulo: 'Situação',
  campo: 'situacaoCadastro',
  render: item => renderizarStatus(item, getStatus)
});

export const COLUNA_SITUACAO_SISTEMA = (getStatus = null) => ({
  titulo: 'Situação Sistema',
  campo: 'situacaoCadastro',
  render: item => renderizarStatus(item, getStatus)
});

// Função para definir quais colunas são fixas (sempre visíveis)
export const definirColunasFixas = (indices = [0, 1]) => indices;

// Função para criar colunas dinamicamente recebendo título, campo e função de mapeamento
export const criarColuna = (titulo, campo, mapFn = valor => valor) => ({
  titulo,
  campo,
  render: item => {
    const valor = String(campo)
      .split('.')
      .reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : undefined), item);
    return mapFn(valor, item);
  },
});


// Cria coluna Hash específica com largura variável
export const criarColunaHash = (titulo, campo, opcoes = {}) => ({
  titulo,
  campo,
  render: item => renderizarHash(item),
  ...opcoes
});

// Renderização do hash
export const renderizarHash = (item) => {
  const valor = item['hashKey'];
  if (!valor) return <>-</>;

  return (
    <div className={'chave-hash'} style={{ display: 'inline-block', width: '100%' }}>
      <CampoHash value={valor} qtdEcript={1.0} />
    </div>
  );
};

export const criarColunaDesc = (titulo, campo, mapFn = (valor) => valor) => ({
  titulo,
  campo,
  alignHeader: 'left',
  className: 'coluna-acao-personalizada',
  render: item => renderizarDesc(item, campo),
});

export const renderizarDesc = (item, campo) => {
  const valor = campo
    .split('.')
    .reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : undefined), item);

  if (!valor) return <>-</>;

  return (
    <div
      className="chave-desc"
      style={{
        display: 'inline-block',
        minWidth: '350px',
        width: '100%',
        textAlign: 'left',
        whiteSpace: 'normal',
      }}
    >
      {valor}
    </div>
  );
};